"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAuthUser = exports.getStatsUser = exports.getSessionId = void 0;
var uuid_1 = require("uuid");
function isUuid(userToken) {
    return (userToken === null || userToken === void 0 ? void 0 : userToken.match(/^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/)) || false;
}
function getSessionId(getCookie, setCookie) {
    var sessionId = getCookie("sessionId");
    if (!(sessionId && isUuid(sessionId))) {
        sessionId = uuid_1.v4();
        setCookie("sessionId", sessionId, (1 / 60) * 5);
    }
    return sessionId;
}
exports.getSessionId = getSessionId;
function getStatsUser(getCookie, setCookie) {
    var user = getCookie('usu_tiendeo');
    if (!(user && isUuid(user))) {
        user = uuid_1.v4();
    }
    setCookie('usu_tiendeo', user, 365 * 24);
    return user;
}
exports.getStatsUser = getStatsUser;
function getAuthUser(getCookie) {
    var id = getCookie('EndUserId');
    if (id) {
        var token = getCookie('AccessToken');
        return {
            id: id,
            token: token
        };
    }
    else
        return null;
}
exports.getAuthUser = getAuthUser;
//# sourceMappingURL=user.js.map